import React from 'react';
import { useSelector } from 'react-redux';
import { CardContent, Typography, CircularProgress, Link } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Trans } from 'react-i18next';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { Selectors } from '../../selectors';
import { BRAND_NAME, CONTACT_EMAIL, CONTACT_PHONENO } from '../../constants';

const useStyles = makeStyles({
    cardContent: {
        flex: '1 1 0px',
        overflow: 'auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});
type Props = {
    changeNextLabel: Function;
    changeNextEnabled: Function;
    name: string;
    organization: string | null;
    email: string;
};

export const Complete: React.FC<Props> = (props: Props) => {
    const { t } = useLanguageLocale();
    const classes = useStyles();
    const registration = useSelector(Selectors.Registration.registration);
    const { changeNextLabel, name, email } = props;

    changeNextLabel(t('ACTIONS.CONTINUE'));

    return (
        <CardContent style={{ flex: '1 1 0px', overflow: 'auto' }} data-testid="complete-content">
            {registration.loading && !registration.success && (
                <>
                    <CardContent className={classes.cardContent}>
                        <CircularProgress id={'progress-spinner'} />
                    </CardContent>
                </>
            )}
            {!registration.loading && registration.success && (
                <>
                    <Typography variant={'h6'} data-testid="success-header">
                        <Trans i18nKey={'MESSAGES.WELCOME_NAME'}>
                            Welcome, <b style={{ fontWeight: 600 }}>{{ name }}</b>!
                        </Trans>
                    </Typography>
                    <Typography data-testid="success-body">
                        <Trans i18nKey={'REGISTRATION.SUCCESS_MESSAGE'}>
                            Your account has been successfully created with the email{' '}
                            <b style={{ fontWeight: 600 }}>{{ email }}</b>. To access the
                            {BRAND_NAME} Suite application, use the continue button below.
                        </Trans>
                    </Typography>
                </>
            )}
            {!registration.loading && !registration.success && registration.errorCode === '2018' && (
                <Typography data-testid="failure-content" variant="subtitle1">
                    {t(`ERROR_MESSAGES.${registration.errorCode}`)}
                    <Link underline="always" href={`mailto:${CONTACT_EMAIL}`}>
                        {CONTACT_EMAIL}
                    </Link>{' '}
                    or by phone{' '}
                    <Link href={`tel:${CONTACT_PHONENO}`} style={{ textDecoration: 'none' }}>
                        {CONTACT_PHONENO}
                    </Link>
                    .
                </Typography>
            )}
            {!registration.loading && !registration.success && registration.errorCode !== '2018' && (
                <Typography data-testid="failure-content">{t('REGISTRATION.FAILURE_MESSAGE')}</Typography>
            )}
        </CardContent>
    );
};
